import { Model } from 'app/model/backendmodel';
import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Metamodel } from 'app/model/base/model';
import { LinkedServiceAdapter } from 'app/model/adapters/linkedservices/linkedservice.adapter';
import { IModel, ITridentResource, OneLakeFileLinkedService } from 'shell-models-lib';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(OneLakeFileLinkedService),
    asynchronous: true,
    adapts: {
        name: '*',
        properties: {
            description: '*',
            type: '*',
            connectVia: '*',
            parameters: '*'
        }
    }
})
export class OneLakeFileLinkedServiceAdapter extends LinkedServiceAdapter<OneLakeFileLinkedService> {
    // Defined (not omitted) so the base does not spill the raw trident resource into properties.
    protected override toAzureTypeProperties = (
        _tridentResource: ITridentResource
    ): Model.LinkedService['typeProperties'] => ({});

    protected modelConstructor(): new () => OneLakeFileLinkedService {
        return OneLakeFileLinkedService;
    }

    protected model(): IModel {
        return OneLakeFileLinkedService.MODEL;
    }

    protected async propertiesToResourceAsync(
        _linkedService: OneLakeFileLinkedService,
        linkedServiceResource: Model.LinkedServiceResource
    ): Promise<Model.LinkedServiceResource> {
        const properties = this.properties(linkedServiceResource) as Model.LinkedServiceResource['properties'];
        properties.type = Metamodel.modelFor(OneLakeFileLinkedService).name;
        return linkedServiceResource;
    }

    protected async propertiesToModelAsync(
        _linkedServiceResource: Model.LinkedServiceResource,
        linkedService: OneLakeFileLinkedService
    ): Promise<OneLakeFileLinkedService> {
        return linkedService;
    }
}
